import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { APP_NAME, APP_NAME_WEAK } from '@vuokramani/shared';
import fi from './locales/fi.json';
import sv from './locales/sv.json';
import en from './locales/en.json';

/**
 * Kaikki käyttäjälle näkyvät tekstit tulevat käännöstiedostoista (locales/*.json).
 * Suomi on perus; puuttuvat ruotsin ja englannin käännökset näytetään suomeksi.
 * Admin-osio on vain suomeksi eikä käytä näitä tiedostoja.
 */
export const LANGUAGES = ['fi', 'sv', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];

const STORAGE_KEY = 'vm-lang';

function initialLanguage(): Language {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && (LANGUAGES as readonly string[]).includes(saved)) return saved as Language;
  } catch {
    // ei tallennustilaa
  }
  return 'fi';
}

void i18n.use(initReactI18next).init({
  resources: { fi: { translation: fi }, sv: { translation: sv }, en: { translation: en } },
  lng: initialLanguage(),
  fallbackLng: 'fi',
  // {{app}} = palvelun nimi (brand.ts), jotta nimen voi vaihtaa yhdestä paikasta.
  // {{appWeak}} = heikko vartalo taivutuksiin: {{appWeak}}n, {{appWeak}}ssa (Vuokrantin, Vuokrantissa).
  interpolation: {
    escapeValue: false,
    defaultVariables: { app: APP_NAME, appWeak: APP_NAME_WEAK },
  },
  returnNull: false,
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // ei tallennustilaa
  }
});
document.documentElement.lang = i18n.language;

export default i18n;
